<div
    class="flex max-h-[calc(100dvh-6.5rem)] gap-x-8 rounded-2xl bg-surface-A pt-16 pr-8 pl-16 text-text shadow-tip"
    interactaReverseTheme
    [class]="showExpandButton() ? 'pb-8' : 'pb-16'"
>
    <div class="flex min-w-0 grow flex-col gap-y-8">
        <div class="min-h-0 overflow-y-auto pe-4">
            @if (expanded()) {
                <div class="flex flex-col gap-y-32">
                    @for (group of groups(); track group.id) {
                        <interacta-toast-notification-group [group]="group" />
                    }
                </div>
            } @else {
                @if (groups()[0]; as firstGroup) {
                    <interacta-toast-notification-group
                        [clamped]="true"
                        [group]="firstGroup"
                        (overflowChanged)="collapsedOverflow.set($event)"
                    />
                }
            }
        </div>
        @if (showExpandButton()) {
            <interacta-load-more
                [label]="'TOAST_NOTIFICATION.SHOW_ALL' | translate"
                (loadMore)="expandPanel.emit()"
            />
        }
    </div>
    <button
        class="shrink-0 self-start"
        data-testid="toast-panel-close"
        interacta-icon-button
        type="button"
        [icon]="'close'"
        [label]="'UI.BUTTON.CLOSE' | translate"
        [tooltipClass]="'tooltip-reverse-theme'"
        (click)="closePanel.emit()"
    ></button>
</div>
